export enum ESearchType {
    WORKSPACE = 'WORKSPACE',
    BOOKING = 'BOOKING',
    BUSINESS = 'BUSINESS',
}
